export enum RealAssetType {
  EQUITY_STOCK = 'EquityStockAsset',
  EQUITY_ETF = 'EquityEtfAsset',
  EQUITY_ETC = 'EquityEtcAsset',
  EQUITY_COMPLEX_ETF = 'EquityComplexEtfAsset',
  EQUITY_COMPLEX_ETC = 'EquityComplexEtcAsset',
}
